import React, { useState } from 'react';
import './Menu.css';

const categories = ['All', 'Starters', 'Mains', 'Desserts'];

const FALLBACK = 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&auto=format&fit=crop&q=80';

const dishes = [
  { id:1, category:'Starters', name:"Truffle Velvet Bisque",    price:'$34', description:"A soup so luxurious it makes your other soups feel underdressed for the occasion.",           image:'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=600&auto=format&fit=crop&q=85', tag:"Chef's Pick" },
  { id:2, category:'Starters', name:"Smoked Salmon Lattice",    price:'$28', description:"Hand-woven by our chef at 6am. Not because it's necessary, but because art takes time.",     image:'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=600&auto=format&fit=crop&q=85', tag:'Seasonal'    },
  { id:3, category:'Mains',    name:"Wagyu A5 Silence",         price:'$98', description:"So tender, guests have been known to weep softly. We keep tissues at every table.",          image:'https://images.unsplash.com/photo-1544025162-d76694265947?w=600&auto=format&fit=crop&q=85', tag:'Signature'   },
  { id:4, category:'Mains',    name:"Saffron-Poached Sea Bass", price:'$62', description:"The fish lived a good life. We honour it with 47 steps of preparation and a gold leaf hat.", image:'https://images.unsplash.com/photo-1534482421-64566f976cfa?w=600&auto=format&fit=crop&q=85', tag:null          },
  { id:5, category:'Mains',    name:"Confit Duck Noir",         price:'$56', description:"Slow-cooked for 18 hours because we had a feeling you might show up for dinner.",            image:'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&auto=format&fit=crop&q=85', tag:null          },
  { id:6, category:'Desserts', name:"Dark Matter Soufflé",      price:'$24', description:"Collapses after 4 minutes. Much like your willpower when you first saw the menu.",           image:'https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=600&auto=format&fit=crop&q=85', tag:'Fan Favourite'},
  { id:7, category:'Desserts', name:"Gold Leaf Panna Cotta",    price:'$22', description:"It's basically yogurt wearing a tuxedo. The most well-dressed thing you'll eat all year.",   image:'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=600&auto=format&fit=crop&q=85', tag:null          },
  { id:8, category:'Starters', name:"Caviar on Black Ice",      price:'$48', description:"Served at 2°C on obsidian slate. Cold, mysterious, and completely unreasonable. You'll love it.", image:'https://images.unsplash.com/photo-1607301406259-dfb186e15de8?w=600&auto=format&fit=crop&q=85', tag:'Exclusive'   },
];

export default function Menu() {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? dishes : dishes.filter((d) => d.category === active);

  return (
    <section className="menu" id="menu">
      <div className="section-inner">
        <div className="menu-header reveal">
          <div className="gold-rule"><span /><em>The Menu</em><span /></div>
          <h2 className="section-title">A symphony of <em>flavour</em></h2>
          <p className="menu-subtitle">Each dish is composed like a piece of music — every note deliberate, every silence intentional.</p>
        </div>
        <div className="menu-filter reveal delay-2">
          {categories.map((cat) => (
            <button key={cat} className={`menu-filter-btn ${active === cat ? 'active' : ''}`} onClick={() => setActive(cat)}>{cat}</button>
          ))}
        </div>
        <div className="menu-grid">
          {filtered.map((dish, i) => (
            <article key={dish.id} className={`menu-card reveal delay-${(i % 4) + 1}`}>
              <div className="menu-card-img-wrap">
                <img src={dish.image} alt={dish.name} className="menu-card-img" loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = FALLBACK; }} />
                {dish.tag && <span className="menu-card-tag">{dish.tag}</span>}
                <div className="menu-card-hover-overlay"><span className="menu-card-hover-text">View Details</span></div>
              </div>
              <div className="menu-card-body">
                <div className="menu-card-top">
                  <span className="menu-card-category">{dish.category}</span>
                  <span className="menu-card-price">{dish.price}</span>
                </div>
                <h3 className="menu-card-name">{dish.name}</h3>
                <p className="menu-card-desc">{dish.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
